import { Box, Step, StepLabel, Stepper, Typography, useTheme } from '@mui/material';
import { useIntl } from 'react-intl';

import { useAppSelector } from '../../../lib/store';
import { CREATE_PROJECT_WIZARD_STEPS } from '../constants';
import { selectActiveStep } from '../state/selector';

export const WizardSidebar = () => {
  const theme = useTheme();
  const activeStep = useAppSelector(selectActiveStep);
  const steps = CREATE_PROJECT_WIZARD_STEPS;
  const { formatMessage } = useIntl();
  return (
    <Box id="wizard-sidebar" sx={{ width: '350px', pt: theme.spacing(4) }}>
      <Stepper activeStep={activeStep} orientation="vertical">
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel>
              {formatMessage({ id: `createProjectWizard.step.${label}.title` })}
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
};
